import { USE_CONTENTSTACK_QUERY_TYPES } from '../store/Constants'

/**
 * Builds a Contentstack query filter with taxonomy, instruction type,
 * operating system, tenant type, and sidebar type conditions.
 *
 * @param {string} taxonomyCategory - The printer_family taxonomy value to filter by.
 * @param {string} query_type - One of USE_CONTENTSTACK_QUERY_TYPES.
 * @param {object} additional_params - Extra query parameters (instruction, operatingSystem, etc.).
 * @returns {function} A query_modifier function compatible with useContentStackLib.
 */
const buildContentStackQuery =
  (taxonomyCategory, query_type, additional_params) =>
  ({ query, newQuery }) => {
    const { instruction, tenant_type, type, operatingSystem } =
      additional_params

    const taxQuery = newQuery().or(
      newQuery().notExists(`taxonomies.printer_family`),
      newQuery().where(`taxonomies.printer_family`, taxonomyCategory)
    )

    let finalQuery = query.and(taxQuery)

    if (instruction) {
      finalQuery = finalQuery.and(newQuery().where('type', instruction))
    }
    if (operatingSystem) {
      finalQuery = finalQuery.and(
        newQuery().or(
          newQuery().notExists('operating_system.operating_system'),
          newQuery().where('operating_system.operating_system', {
            $in: [operatingSystem.toUpperCase()]
          })
        )
      )
    }
    if (tenant_type) {
      finalQuery = finalQuery.and(
        newQuery().where('tenant_type.tenant', tenant_type)
      )
    }
    if (query_type === USE_CONTENTSTACK_QUERY_TYPES.SIDEBAR_TYPE && type) {
      finalQuery = finalQuery.and(newQuery().where('type', type))
    }

    return finalQuery
  }

export default buildContentStackQuery
